export default "__VITE_ASSET__4zrrClfC__"